<template>
    <div>
        <zm-tabs @tab-click="handleTabClick"
            v-model="activeName">
            <zm-tab-pane label="Notification Channel" name="notificationChannel">
            </zm-tab-pane>
            <zm-tab-pane label="Notification Rule" name="notificationRule">
            </zm-tab-pane>
            <zm-tab-pane label="Alarm Rule" name="alarmRule">
            </zm-tab-pane>
            <zm-tab-pane label="Alarm Record" name="alarmRecord">
            </zm-tab-pane>
        </zm-tabs>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'monitorManagement',
    data () {
        return {
            activeName: 'notificationChannel'
        }
    },
    created () {
        this.activeName = this.$route.name || 'notificationChannel'
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    methods: {
        handleTabClick (tab, event) {
            localStorage.setItem('notificationType', 0)
            if (tab.name === 'notificationChannel') {
                this.$router.push('/dashboard/monitorManage/notificationChannel')
            } else if (tab.name === 'notificationRule') {
                this.$router.push('/dashboard/monitorManage/notificationRule')
            } else if (tab.name === 'alarmRule') {
                this.$router.push('/dashboard/monitorManage/alarmRule')
            } else if (tab.name === 'alarmRecord') {
                this.$router.push('/dashboard/monitorManage/alarmRecord')
            } else {
                console.log('error')
            }
            localStorage.params = ''
            localStorage.path = this.$route.path
        }
    }
}
</script>
